import Modal from "react-bootstrap/Modal";
import { useEffect, useState } from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import Header from "./Header";
import { storage } from "./firebase";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { arr } from "./numbers";
import { GetAllTokens, onMint } from "../utlis/utils";
import { toast } from "react-toastify";
import axios, * as others from 'axios';


const Home = () => {
  const [show, setShow] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [showS, setShowS] = useState(false);
  const [plotID, setPlotID] = useState(1);
  const [name, setName] = useState("");
  const [imageForLocal, setImageForLocal] = useState("");
  const [description, setDescription] = useState("");
  const [loadingState, setLoadingState] = useState(false);
  const [image, setImage] = useState(null);
  const [photoURL, setPhotoURL] = useState("");
  const [ownerupdatebtn, setownerupdatebtn] = useState("none");
  const [allData, setAllData] = useState([]);
  const [alldetails, setAllDetails] = useState([]);
  const [showDetailsData, setShowDetailsData] = useState([]);
  const [updateModel, setupdateModel] = useState(false);
  const [twitterlink, setTwitter] = useState("https://www.twitter.com");
  const [instagramlink, setInstagram] = useState("https://www.instagram.com");
  const [telegramlink, setTelegram] = useState("https://telegram.org/");
  const [ownertemp, setownertemp] = useState("");

  //backend api link
  const api = axios.create(
    {
      baseURL: "https://bleeny-server.herokuapp.com/"
      // baseURL: "http://localhost:3001/"
    }
  )

  //create all tables with 1-16364 data
  function tableCreate() {

    setLoadingState(true)
    console.log("table create true", loadingState);
    var body = document.getElementById("myTable");
    var tbl = document.createElement("table");
    tbl.style.width = "100%";
    tbl.setAttribute("border", "1");
    var trNum = Math.sqrt(arr.length);

    var arrNum = 0;
    for (var i = 0; i < trNum; i++) {
      var tr = document.createElement("tr");
      for (var j = 0; j < trNum; j++) {

        var td = document.createElement("td");

        const matrix = ((j) - 64) + "," + ((i + 1) - 64);

        td.appendChild(document.createTextNode(matrix));
        td.setAttribute("id", ((j) - 64) + "," + ((i + 1) - 64));
        td.style.position = "relative";
        td.classList.add("mytd");
        td.onclick = function (e) {

          handleShow(e);
        };
        tr.appendChild(td);
        arrNum++;
      }
      tbl.appendChild(tr);

    }
    body.appendChild(tbl);


    console.log("table create false", loadingState);
  }

  function handleDetailModel(e) {
    setShowS(true)
    setPlotID(e.target.id);
  }

  function checkvalidation() {
    let error = false;
    if (name == "" || name == null) {
      toast("please add name", {
        toastId: "customId1",
      });
      error = true;
    }
    if (description == "" || description == null) {
      toast("please add description", {
        toastId: "customId2",
      });
      error = true;
    }

    if (photoURL == "" || photoURL == null) {
      toast("please add image", {
        toastId: "customId3",
      });
      error = true;
    }
    return error;
  }
  // upload image to firebase
  const uploadImage = async (e) => {

    if (e.target.files[0]) {
      setLoadingState(true);
      setImage(e.target.files[0]);
      const imgURI = URL.createObjectURL(e.target.files[0]);
      setImageForLocal(imgURI);


      const imageRef = ref(storage, new Date() + e.target.files[0].name);
      const snapshot = await uploadBytes(imageRef, e.target.files[0]);
      const imageLink = await getDownloadURL(imageRef);
      setPhotoURL(imageLink);

      setLoadingState(false);

    }


  };
  const handleClose = () => {
    setShow(false);
    setShowDetail(false);
  };
  const handleCloseS = () => {
    setShowS(false);
  };
  const handleShow = (e) => {
    setShow(true);
    setPlotID(e.target.id);
  };

  const panningHandler = () => {
    document.getElementById("myTable").style.pointerEvents = "none";
  };
  const panningStopHandler = () => {
    document.getElementById("myTable").style.pointerEvents = "auto";
  };


  // get all plot owner with plotid
  const GetPlotOwner = async () => {
    const plotowner = await GetAllTokens();
    setAllData(plotowner);
  };
  const toasifyownertoast = (ownertemp) => {
    return (
      <>
        The Owner Address:
        <br />

        {ownertemp}
      </>
    );

  }

  //change the minted plot to last 4 characters
  const changeMintedbox = () => {

    setLoadingState(true);
    console.log("changeMintedbox true", loadingState);
    for (let i = 0; i < allData.length; i++) {
      if (
        allData[i].uri == null ||
        allData[i].uri == "" ||
        allData[i].uri == undefined
      ) {
      } else {
        const ownerlast3 = allData[i]._address.substr(38, 4);
        document.getElementById(allData[i].uri).innerHTML = ownerlast3;
        document.getElementById(allData[i].uri).onclick = function (e) {
          toast(toasifyownertoast(allData[i]._address), {
            toastId: "ownertemp",
          })
        }

        if (
          window.ethereum &&
          window.ethereum.selectedAddress &&
          allData[i]._address
        ) {
          if (
            window.ethereum.selectedAddress.toLowerCase() ==
            allData[i]._address.toLowerCase()
          ) {
            document.getElementById(allData[i].uri).onclick = function (e) {
              handleDetailModel(e);
            };


          } else {
            document.getElementById(allData[i].uri).onclick = function (e) {
            };

          }
        }
      }
    }

    console.log("changeMintedbox false", loadingState);
  };

  //when click on save button save data to mongo db
  const SavetoMongo = async (plotid) => {

    if (checkvalidation()) {
    } else {
      setLoadingState(true)
      api.post("/insert", { plotid: plotid, name: name, description: description, image: photoURL, twitter: twitterlink, instagram: instagramlink, telegram: telegramlink, owner: window.ethereum.selectedAddress }).then(res => {
        window.location.reload();
      })
      setLoadingState(false)
    }
  }

  //get data from mongo db name image description social media
  const getDataMongo = async () => {
    if (allData.length > 0) {
      setLoadingState(true)
      console.log("getDataMongo true", loadingState);
      api.get("/read").then(res => {

        for (let i = 0; i < res.data.length; i++) {
          let tempArr = alldetails;
          tempArr.push({
            id: res.data[i]._id,
            plotID: res.data[i].plotID,
            name: res.data[i].name,
            description: res.data[i].description,
            imageLink: res.data[i].image,
            owner: res.data[i].owner,
            twitter: res.data[i].twitter,
            instagram: res.data[i].instagram,
            telegram: res.data[i].telegram

          });
          setAllDetails(tempArr);
          if (document.getElementById(res.data[i].plotID) == null) {

          } else {
            document.getElementById(res.data[i].plotID).style.color = "#2B293E";
            let img = document.createElement("img");
            img.src = res.data[i].image;
            img.classList.add("nft-img-home");
            document.getElementById(res.data[i].plotID).appendChild(img);
            document.getElementById(res.data[i].plotID).onclick = function (e) {
              handleShowDetails(e);
            };
          }
          if (i == res.data.length - 1) {
            setLoadingState(false)
            console.log("getDataMongo false", loadingState);
          }
        }
      });
    } else {

    }

  };
  const showUpdateModel = (plotid) => {
    setupdateModel(true)
    setShowDetail(false);
  }
  const updateMongo = (plotid) => {

    if (checkvalidation()) { } else {
      api.put("/update", { plotid: plotid, name: name, description: description, image: photoURL }).then(res => {
        window.location.reload()
      })
      window.location.reload()
    }
  }

  const handleShowDetails = (e) => {
    if (alldetails.length != 0) {
      var name;
      setShowDetail(true);
      setPlotID(e.target.id);
      name = alldetails.find((item) => item.plotID == e.target.id);

      const owner = name.owner.substr(0, 7) + "....." + name.owner.substr(35, 42)
      setShowDetailsData({
        name: name.name,
        description: name.description,
        image: name.imageLink,
        owner: owner,
        twitter: name.twitter,
        instagram: name.instagram,
        telegram: name.telegram

      });
    }
    let result = allData.find((item) => item.uri == e.target.id);
    if (result._address.toLowerCase() == window.ethereum.selectedAddress.toLowerCase()) {
      setownerupdatebtn("block")
    } else {
      setownerupdatebtn("none")
    }
  };
  const CloseUpdateModel = () => {
    setupdateModel(false)
  }
  useEffect(() => {
    tableCreate();
  }, []);

  useEffect(() => {
    GetPlotOwner();

  }, []);
  useEffect(() => {
    changeMintedbox();
  }, [allData]);

  useEffect(() => {
    if (allData) {
      getDataMongo();
    }
  }, [allData])



  return (
    <>

      {/* this is the model which shows nft details */}
      <Modal id="detail-popup" show={showDetail} onHide={handleClose} centered>

        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="model-wrapper">
            <div className="img-wrapper">
              <img
                className="dummy-mine-craft"
                src={showDetailsData.image}
                alt=""
              />
              <h1 className="plot-id">plot ID:{plotID} </h1>
              <h1 className="det-name">Name:{showDetailsData.name} </h1>
              <h1 className="det-desc">
                Description: {showDetailsData.description}
              </h1>
              <h1 className="det-desc">
                Owner Address:<br /> {showDetailsData.owner}
              </h1>

              <div className="social-media-wrap">
                <a href={showDetailsData.twitter} target="_blank" >
                  <img src="../../Assets/images/twitter.png" alt="" className="social-media-single" />
                </a>

                <a href={showDetailsData.instagram} target="_blank">
                  <img src="../../Assets/images/instagram.png" alt="" className="social-media-single" />
                </a>

                <a href={showDetailsData.telegram} target="_blank">
                  <img src="../../Assets/images/telegram.png" alt="" className="social-media-single" />
                </a>

              </div>



            </div>
            {/* <h1 className="plot-number">Plot id: {plotID}</h1> */}
          </div>
          <Modal.Footer>
            <button className="submit-changes">
              Place a bid
            </button>
            <button id="update-btn" className="submit-changes" onClick={() => showUpdateModel(plotID)} style={{ display: ownerupdatebtn }}>
              Update
            </button>
          </Modal.Footer>
        </Modal.Body>
      </Modal>
      {/* first save the name image description in mongodb */}
      <Modal id="modalS" show={showS} onHide={handleCloseS}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="model-wrapper">
            <div className="name-wrapper">
              <h1 className="plot-id">plot ID:{plotID} </h1>
              <label> Name:</label>
              <input
                className="name-input-field"
                type="text"
                placeholder="Name"
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="img-upload-wrapp">
              <label>
                Upload Image:
                <img
                  className="img-picker"
                  src={
                    imageForLocal
                      ? imageForLocal
                      : "../../Assets/images/chooseimg.png"
                  }
                  alt=""
                />
                <input
                  className="upload-image-text"
                  type="file"
                  onChange={uploadImage}
                />
              </label>
            </div>

            <div className="text-area-wrap">
              <label className="description-label"> Description:</label>
              <textarea
                className="text-area-input"
                placeholder="Description"
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
            <div className="social-media-links">
              <div className="name-wrapper">


                <input
                  className="name-input-field"
                  type="text"
                  placeholder="Twitter"
                  onChange={(e) => setTwitter(e.target.value)}
                />
              </div>
              <div className="name-wrapper">


                <input
                  className="name-input-field"
                  type="text"
                  placeholder="Instagram"
                  onChange={(e) => setInstagram(e.target.value)}
                />
              </div>
              <div className="name-wrapper">


                <input
                  className="name-input-field"
                  type="text"
                  placeholder="Telegram"
                  onChange={(e) => setTelegram(e.target.value)}
                />
              </div>
            </div>



          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="submit-changes" onClick={() => SavetoMongo(plotID)}>
            Save Changes
          </button>
        </Modal.Footer>
      </Modal>

      {/* user can update name image description */}
      <Modal id="updateModel" show={updateModel} onHide={CloseUpdateModel}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="model-wrapper">
            <div className="name-wrapper">
              <h1 className="plot-id">plot ID:{plotID} </h1>
              <label> Name:</label>
              <input
                className="name-input-field"
                type="text"
                placeholder="Name"
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="img-upload-wrapp">
              <label>
                Upload Image:
                <img
                  className="img-picker"
                  src={
                    imageForLocal
                      ? imageForLocal
                      : "../../Assets/images/chooseimg.png"
                  }
                  alt=""
                />
                <input
                  className="upload-image-text"
                  type="file"
                  onChange={uploadImage}
                />
              </label>
            </div>

            <div className="text-area-wrap">
              <label className="description-label"> Description:</label>
              <textarea
                className="text-area-input"
                placeholder="Description"
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="submit-changes" onClick={() => updateMongo(plotID)}>
            Update Changes
          </button>
        </Modal.Footer>
      </Modal>
      {/* minting model */}
      <Modal id="first-model" show={show} onHide={handleClose} centered>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="img-wrapper">
            <img
              className="dummy-mine-craft"
              src="../Assets/images/minecraft.png"
              alt=""
            />
          </div>
          <h1 className="plot-number">Plot id: {plotID}</h1>
          <div className="button-wrapper">
            <button
              className="mint"
              onClick={async () => {
                setLoadingState(true);
                let result = await onMint(plotID);
                setLoadingState(false);
              }}
            >
              Mint
            </button>
          </div>
        </Modal.Body>

      </Modal>


      {/* loading frontend */}
      {loadingState ? (
        <div className="loader-wrao" style={{ visibility: "visible" }}>
          <div className="loader"></div>
        </div>
      ) : (
        <div className="loader-wrao" style={{ visibility: "hidden" }}>
          <div className="loader"></div>
        </div>
      )}

      <Header />

      <TransformWrapper
        initialScale={0.065}
        minScale={0.065}
        maxScale={5}
        limitToBounds={false}
        onPanning={panningHandler}
        onPanningStop={panningStopHandler}
        pinch={{ step: 5 }}
        centerOnInit={true}

      >
        <TransformComponent>
          <div id="myTable"></div>


        </TransformComponent>
      </TransformWrapper>
    </>
  );
};
export default Home;
